(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[120],{

/***/ 5759:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(4647);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ GeneralPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1046);
/* harmony import */ var _components_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3427);
/* harmony import */ var _components_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4169);
/* harmony import */ var _components_structured_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6269);





var __N_SSP = true;
function GeneralPage(param) {
    let { isPreview , page: { sections , structuredData , seo , title , locale , publishedAt  } , menu , menuFooter , menuFooterSecondary , settings , url  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo__WEBPACK_IMPORTED_MODULE_3__/* .Seo */ .p, {
                title: title,
                seo: seo,
                url: url
            }),
            settings.website && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_structured_data__WEBPACK_IMPORTED_MODULE_4__/* .WebPageJsonLd */ .VL, {
                        url: url,
                        title: title,
                        locale: locale,
                        seo: seo,
                        website: settings.website,
                        structuredData: structuredData
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_structured_data__WEBPACK_IMPORTED_MODULE_4__/* .ProductsJsonLd */ .RQ, {
                        structuredData: structuredData,
                        website: settings.website
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_structured_data__WEBPACK_IMPORTED_MODULE_4__/* .EventsJsonLd */ .pv, {
                sections: sections
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPreview: isPreview,
                menu: menu,
                menuFooter: menuFooter,
                menuFooterSecondary: menuFooterSecondary,
                settings: settings,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    sections: sections,
                    settings: settings
                }, url)
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [446,46,266,774,888,179], function() { return __webpack_exec__(5759); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);